import styled from 'styled-components';
const ChangeStoreStyled = styled.div`
  background-color: #fff;
  border-radius: 12px;
  min-height: 500px;
  padding: 32px;
  .css-1q60rmi-MuiAutocomplete-endAdornment {
    display: flex;
    /* .MuiIconButton-root {
      width: 16px;
      height: 16px;
    }
    .MuiSvgIcon-root {
      width: 16px;
      height: 16px;
    } */
  }
  .manageStore {
    width: 100%;
  }
  .checkbox-radio-disabled-color .Mui-disabled {
    color: darkgray;
  }
`;
export default ChangeStoreStyled;
